import { render, staticRenderFns } from "./GroupListView.vue?vue&type=template&id=b3808f00"
import script from "./GroupListView.vue?vue&type=script&lang=js"
export * from "./GroupListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports